export class GetInTouchClubModel {
  constructor(user, club, contact) {
    this.email = user.email;
    this.name = `${user.firstName} ${user.lastName}`;
    this.message = contact.message;
    this.subject = contact.subject;
    this.userId = user._id;
    this.clubId = club._id;
    this.clubEmail = club.email;
    this.clubName = club.name;
  }
  // Getter
  get Validate() {
    return this.validateModel();
  }
  // Method
  validate() {
    const errors = {};
    if (!this.subject) {
      errors.subject = {
        message: "Required",
        hasError: true
      };
    }
    if (!this.message) {
      errors.message = {
        message: "Required",
        hasError: true
      };
    }
    return errors;
  }
}



// WEBPACK FOOTER //
// ./src/models/club/getintouch.model.js